// export const configApi = 'http://vigila_migracion.local/api/'
export const configApi = 'https://vigilacontigo.villavicencio.gov.co/api/'
//export const configApi = 'https://api.vigilacontigo.com/api/'
//export const configApi = 'http://localhost:8000/api/'
